import './cardsProductBanners.scss';

// @vendors
import React, { PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const PureRenderMixin = require('react-addons-pure-render-mixin');
const uniq = require('lodash/array/uniq');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const ProductBanner = require('components/commons/productBanner/productBanner');
const InterestsExample = require('components/interestsExample/interestsExample');

// @core
const { FormattedText, formatText }= require('core/i18n').i18n;

// @helpers
const { nonNumericFilter } = require('utilities/stringHelper');
const { canHireCard } = require('utilities/hireCardsHelper');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const getCardsProductBanners = require('constants/productBanners/cardsProductBanners');
const { PROC_PACK_OPEN_YOUNG } = require('utilities/tagging');
const {
    DIAMOND_PACK_HIRING,
    PREMIUM_PACK_HIRING,
    PRODUCT_BANNER_PACK_DIAMOND,
    PRODUCT_BANNER_PACK_PREMIUM,
    OPEN_YOUNG_PACK_KEY
} = require('constants/index');
// @hocs

const {
    MAESTRO_CARD,
    METALLIC_CARD,
    R42_TRAVEL_PLUS_OFF_HIRING,
    VIRTUAL_CREDIT_CARD,
    VIRTUAL_CREDIT_CARD_GLOBAL,
} = require('constants/flagBasedFeatures')


class CardsProductBanners extends PureComponent {
    constructor (props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        this.state = {
            showMore: false
        };

        this.CARDS_PRODUCT_BANNERS_ORDER = [ // Order required by client
            //type => subtype
            'diamondPack',
            'premiumPack',
            '500801',//open credit
            '500003',//revolving
            '500803',//virtualcredit
            '532001',//via t
            '506003',//ecard
            '506010',//openyoung
            OPEN_YOUNG_PACK_KEY, // Pack Open Young
            '506002',//open debit
            '506005', // at home abroad
            '506012',//Virtual Debit Card
            'maestro', // maestro card
            'metallic', // Metallic Card
        ];

        if (props.charityCardsEnable && !props.isCollectiveUser) {
            // charity behind a flag
            this.CARDS_PRODUCT_BANNERS_ORDER.unshift('506011');
        } else if (props.isCollectiveUser){
            // move premium pack to top for collectivos user
            let premiumPackIndex = this.CARDS_PRODUCT_BANNERS_ORDER.indexOf('premiumPack');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(premiumPackIndex,1);
            this.CARDS_PRODUCT_BANNERS_ORDER.unshift('premiumPack');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(1, 0, '506011')
        }

        if (!props.atHomeAbroadEnabled) {
            let atHomeAbroadIndex = this.CARDS_PRODUCT_BANNERS_ORDER.indexOf('506005');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(atHomeAbroadIndex,1);
        }

        if (!props.revolvingEnabled) {
            let revolvingIndex = this.CARDS_PRODUCT_BANNERS_ORDER.indexOf('500003');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(revolvingIndex,1);
        }
        //Checks for general flag and then for passport flag
        if (!props.virtualCreditGlobalEnabled || !props.virtualCreditPassportEnabled) {
            let virtualCreditIndex = this.CARDS_PRODUCT_BANNERS_ORDER.indexOf('500803');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(virtualCreditIndex, 1);
        }

        if (!props.metallicCardEnabled) {
            let metallicIndex = this.CARDS_PRODUCT_BANNERS_ORDER.indexOf('metallic');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(metallicIndex, 1);
        }

        if (!props.maestroCardEnabled) {
            let materCardIndex = this.CARDS_PRODUCT_BANNERS_ORDER.indexOf('maestro');
            this.CARDS_PRODUCT_BANNERS_ORDER.splice(materCardIndex, 1);
        }

        this.CARDS_PRODUCT_BANNERS_ORDER.unshift('500802'); // move Neruda card to top
        this.CARDS_PRODUCT_BANNERS_ORDER.unshift('500805'); // move Vanity Fair to top
        this.CARDS_PRODUCT_BANNERS_ORDER.unshift('500804'); // move EH card to top
    }

    getProductBannersOrder = userCardsAdvertisementTypes => {
        const accountTypesContractedByUser = [];
        const accountTypesNonContractedByUser = [];

        this.CARDS_PRODUCT_BANNERS_ORDER.forEach(accountType => {
            if (userCardsAdvertisementTypes.includes(accountType)) {
                accountTypesContractedByUser.push(accountType);
            } else {
                accountTypesNonContractedByUser.push(accountType);
            }
        })

        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    getUserOwnedProductBannersCode = () => {
        const output = [];

        this.props.immCards.get('byId').forEach(immCard => {
            const newProduct = immCard.get('newProduct');
            const productSubType = immCard.get('productSubType');
            const cardType = nonNumericFilter(newProduct + productSubType);

            if (this.CARDS_PRODUCT_BANNERS_ORDER.includes(cardType)) {
                output.push(cardType);
            } else if (cardType === '501003' || cardType === '506009') {// 501003 - premiumPack credit / 506009 - premiumPack debit
                output.push('premiumPack');
            } else if (cardType === '501002' || cardType === '506008') {// 501002 - diamondPack credit / 506008 - diamondPack debit
                output.push('diamondPack');
            }

        });

        return uniq(output);
    }

    buildProductBanners = orderedProductBanners => {
        const {
            amount,
            // creditCardEnabled,
            flagBasedFeatures,
            immCommercialAds,
            immCollectivesCardContent,
            isCollectiveUser,
            showRevolving,
            virtualDebitCardHiringEnabled,
            originCountry,
            r42TravelPlusOffHiringEnabled,
        } = this.props;
        const banners = orderedProductBanners.map((bannerKey, index) => {
            const {
                // credit,
                id,
                featureTogglingKey,
                featureTogglingFn,
                link,
                sidebarExtraImgId,
                sidebarImgAlt,
                sidebarImgUrl,
                sidebarImgUrlByCountry,
                sidebarImgId,
                sidebarImgIdByCountry,
                sidebarImgIdByCountryStandardOff,
            } = getCardsProductBanners(flagBasedFeatures)[bannerKey];

            let imageKey;

            if (['maestro', '506002'].includes(bannerKey) && r42TravelPlusOffHiringEnabled) {
                imageKey = (!!sidebarImgIdByCountryStandardOff && !!originCountry && sidebarImgIdByCountryStandardOff[originCountry.toLowerCase()]) || sidebarImgId;
            }else{
                imageKey = (!!sidebarImgIdByCountry && !!originCountry && sidebarImgIdByCountry[originCountry.toLowerCase()]) || sidebarImgId;
            }

            const immCommercialCard = immCommercialAds.getIn(['byId', imageKey]);

            let cardImg = immCommercialCard && immCommercialCard.getIn(['fieldImageLarge', 'url']);
            if (bannerKey === '506011') { // charity card should display smaller img size due to bad rendering in IE 11 (OBK314-54428)
                cardImg = immCommercialCard && immCommercialCard.getIn(['fieldImageMedium', 'url']);
            }

            let {
                advantages,
                subtitle,
                title
            } = getCardsProductBanners(flagBasedFeatures)[bannerKey];
            let tagFree = false;

            if (bannerKey === '500003' && !showRevolving) {
                return null;
            }

            if (bannerKey === '506012' && !virtualDebitCardHiringEnabled) {
                return null;
            }

            let cardExtraImg = '';
            let processType;

            if (!!sidebarExtraImgId) {
                const immCommercialCard = immCommercialAds.getIn(['byId', sidebarExtraImgId]);
                cardExtraImg = immCommercialCard && immCommercialCard.getIn(['fieldImageLarge', 'url']);
            }

            //For Collective User to show diamond pack
            if (id === PRODUCT_BANNER_PACK_DIAMOND && !!immCollectivesCardContent.get(DIAMOND_PACK_HIRING)) {
                const immCollectivesContent = immCollectivesCardContent.get(DIAMOND_PACK_HIRING);
                title = immCollectivesContent.get('title') || title;
                subtitle = immCollectivesContent.get('subtitle') || subtitle;
                if(immCollectivesContent.get('advantages')) {
                    advantages = immCollectivesContent.get('advantages').toJS();
                }
                tagFree = true;
            }

            //For Collective User to show premium pack
            if (id === PRODUCT_BANNER_PACK_PREMIUM && !!immCollectivesCardContent.get(PREMIUM_PACK_HIRING)) {
                const immCollectivesContent = immCollectivesCardContent.get(PREMIUM_PACK_HIRING);
                title = immCollectivesContent.get('title') || title;
                subtitle = immCollectivesContent.get('subtitle') || subtitle;
                if(immCollectivesContent.get('advantages')) {
                    advantages = immCollectivesContent.get('advantages').toJS();
                }
                tagFree = true;
            }

            if (bannerKey === OPEN_YOUNG_PACK_KEY) {
                processType = PROC_PACK_OPEN_YOUNG;
            }

            if (!canHireCard(flagBasedFeatures, featureTogglingKey, featureTogglingFn)) {
                return null;
            }

            let isCollectivePreferenceAllowed = isCollectiveUser;
            if (id === PRODUCT_BANNER_PACK_DIAMOND || id === PRODUCT_BANNER_PACK_PREMIUM) {
                isCollectivePreferenceAllowed = (id === PRODUCT_BANNER_PACK_DIAMOND) ?
                    !!immCollectivesCardContent.get(DIAMOND_PACK_HIRING) : !!immCollectivesCardContent.get(PREMIUM_PACK_HIRING)
            }

            const sidebarImg = (sidebarImgUrlByCountry && sidebarImgUrlByCountry[originCountry.toLowerCase()]) || sidebarImgUrl
            return (
                <ProductBanner
                    advantages={advantages}
                    id={id}
                    isCollectiveUser={isCollectivePreferenceAllowed}
                    key={`cards-product-banners-${index}`}
                    link={link}
                    processType={processType}
                    sidebarExtraImgCardUrl={cardExtraImg}
                    sidebarImgAlt={sidebarImgAlt}
                    sidebarImgCardUrl={cardImg}
                    sidebarImgUrl={sidebarImg}
                    sidebarType="card-art"
                    subtitle={subtitle}
                    tagFree={tagFree}
                    title={title}
                />
            );
        }).filter(banner => banner);

        return (
            <Fragment>
                {!this.state.showMore ? banners.slice(0, amount) : banners}
                {(banners && banners.length > this.props.amount) && !this.state.showMore && this.buildShowMoreButton(banners)}
            </Fragment>
        );
    }

    buildShowMoreButton = () => {
        return (
            <div className="cards-product-banners__show-more-button">
                <OKButton modifier="secondary" inverse={true} onClick={this.handleShowMoreClick}>
                    <FormattedText value="productBanner-seeMore" injectedStrings={[formatText('cards-cards')]} />
                </OKButton>
            </div>
        )
    }

    handleShowMoreClick = () => {
        this.setState({
            showMore: true
        });
    }

    render () {
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode();
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode);
        return (
            <section className="cards-product-banners">
                <header className="cards-product-banners__header">
                    <FormattedText value="productBanner-meetCards" />
                </header>
                {this.buildProductBanners(orderedProductBanners)}
                <InterestsExample keyText={'productBanner-cardsInterestsExample'} />
            </section>
        );
    }
}

CardsProductBanners.propTypes = {
    atHomeAbroadEnabled: PropTypes.bool,
    amount: PropTypes.number,
    charityCardsEnable: PropTypes.bool,
    collectivesDiamondCardEnabled: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    getCollectivesCardContent: PropTypes.func,
    immCards: PropTypes.object.isRequired,
    immCommercialAds: PropTypes.object.isRequired,
    immCollectivesCardContent: PropTypes.object,
    isCollectiveUser: PropTypes.bool,
    openYoungAddDocumentationEnabled: PropTypes.bool,
    packOpenYoungEnabled: PropTypes.bool,
    revolvingEnabled: PropTypes.bool,
    showRevolving: PropTypes.bool,
    virtualCreditGlobalEnabled: PropTypes.bool.isRequired,
    virtualCreditPassportEnabled: PropTypes.bool.isRequired,
    virtualDebitCardHiringEnabled: PropTypes.bool,
    metallicCardEnabled: PropTypes.bool,
    maestroCardEnabled: PropTypes.bool,
    creditCardEnabled: PropTypes.string,
    originCountry: PropTypes.string,
    r42TravelPlusOffHiringEnabled: PropTypes.bool,
};

CardsProductBanners.defaultProps = {
    isCollectiveUser: false,
    charityCardsEnable: false
}

module.exports = connect(
    state => ({
        revolvingEnabled: state.flagBasedFeatures.get('hire-card-revolving-enabled'),
        atHomeAbroadEnabled: state.flagBasedFeatures.get('hire-card-at-home-abroad-enabled'),
        charityCardsEnable: state.flagBasedFeatures.get('charity-cards-enabled'),
        virtualCreditGlobalEnabled: state.flagBasedFeatures.get(VIRTUAL_CREDIT_CARD_GLOBAL),
        virtualCreditPassportEnabled: state.flagBasedFeatures.get(VIRTUAL_CREDIT_CARD),
        creditCardEnabled: state.flagBasedFeatures.get('credit'),
        immCollectivesCardContent: state.collectivesCardContent,
        virtualDebitCardHiringEnabled: state.flagBasedFeatures.get('virtual-debit-card-hiring-enabled'),
        openYoungAddDocumentationEnabled: state.flagBasedFeatures.get('add-documentation-openyoung-enabled'),
        metallicCardEnabled: state.flagBasedFeatures.get(METALLIC_CARD),
        maestroCardEnabled: state.flagBasedFeatures.get(MAESTRO_CARD),
        originCountry: state.profile.get('originCountry'),
        r42TravelPlusOffHiringEnabled: state.flagBasedFeatures.get(R42_TRAVEL_PLUS_OFF_HIRING),
    })
)(withFeatureToggling(CardsProductBanners));
